import styled from 'styled-components';
import {bordersStyles, typographyStyles} from '../../../../utils/styles';

const PANEL_BODY_PADDING = '24px';

const StyledVendorDetailsPanel = styled.div`
  display: flex;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const StyledVendorDetailsPanelContainer = styled.div`
  position: relative;
  top: 0;
  width: inherit;

  & > div {
    transition: opacity .3s ease;
  }
`;

const StyledVendorDetailsPanelContent = styled.div`
  ${bordersStyles.light};
  background-color: ${props => props.theme.colors.neutral_1};
`;

const StyledVendorDetailsPanelBody = styled.div`
  padding: ${PANEL_BODY_PADDING};
  overflow: auto;
  max-height: calc(100vh - (66px + 56px + ${PANEL_BODY_PADDING} * 2));
`;

const StyledVendorDetailsPanelHeader = styled.div`
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.neutral_4};
  color: ${props => props.theme.colors.neutral_10};
  display: flex;
  justify-content: space-between;
  padding: 0 24px;
  min-height: 56px;

  .ant-space-item {
    display: flex;
  }

  button.ant-btn {
    &.ant-btn-text {
      ${typographyStyles.heading.h5};
      align-items: center;
      color: ${props => props.theme.colors.neutral_10};
      display: flex;
      border: none;

      .ant-btn-icon {
        display: flex;
      }

      svg {
        path {
          transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
          fill: ${props => props.theme.colors.neutral_6};
          stroke: ${props => props.theme.colors.neutral_6};
        }
      }

      &:hover {
        svg {
          path {
            fill: rgba(0, 0, 0, 0.88);
            stroke: rgba(0, 0, 0, 0.88);
          }
        }
      }
    }

    &.ant-btn-dangerous {
      display: flex;
      align-items: center;
      padding: 0;

      .ant-btn-icon {
        display: flex;
        align-items: center;
      }

      svg {
        path {
          fill: ${props => props.theme.colors.neutral_6};
          stroke: none;
        }
      }

      &:not(:disabled):not(.ant-btn-disabled):hover {
        &:hover {
          svg {
            path {
              fill: ${props => props.theme.colors.functional_danger};
              stroke: none;
            }
          }
        }
      }
    }
  }
`;

const StyledVendorDetailsPanelHeaderText = styled.div`
  ${typographyStyles.heading.h5};
`;

export {
  StyledVendorDetailsPanel,
  StyledVendorDetailsPanelContainer,
  StyledVendorDetailsPanelContent,
  StyledVendorDetailsPanelBody,
  StyledVendorDetailsPanelHeader,
  StyledVendorDetailsPanelHeaderText,
};
